module.exports = __webpack_public_path__ + "img/Cloud-migration.dceb7ff.jpg";